const SimpleWishlist = (() => {
  const COOKIE_NAME = 'wishlist';

  const getWishlist = () => {
    const match = document.cookie.match(
      new RegExp('(^|;) ?' + COOKIE_NAME + '=([^;]*)(;|$)')
    );
    return match ? JSON.parse(decodeURIComponent(match[2])) : [];
  };

  const saveWishlist = (list) => {
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + 30);
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
      JSON.stringify(list)
    )}; expires=${expiry.toUTCString()}; path=/`;
  };

  const updateAriaState = (el, isActive) => {
    if (!el) return;

    const title = el.dataset.title || 'product';
    el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    el.setAttribute(
      'aria-label',
      isActive
        ? `Remove ${title} from wishlist`
        : `Add ${title} to wishlist`
    );
  };

  const updateHeader = (list) => {
    document.querySelectorAll('.wishlist_link').forEach((link) => {
      const bubble = link.querySelector('.wishlist-bubble');
      if (!bubble) return;

      if (list.length) {
        link.classList.add('active');
        bubble.classList.remove('hidden');
        bubble.textContent = list.length;
      } else {
        link.classList.remove('active');
        bubble.classList.add('hidden');
        bubble.textContent = '';
      }
    });
  };

  const toggleProduct = (el) => {
    if (!el) return;

    const varId = el.dataset.var?.toString();
    if (!varId) return;

    let list = getWishlist();
    const isWishlistPage = window.location.pathname.includes('wishlist');

    const index = list.findIndex(
      (item) => item.var.toString() === varId
    );

    if (index > -1) {
      const removedItem = list.splice(index, 1)[0];
      el.classList.remove('active');
      updateAriaState(el, false);

      console.log('Removed:', removedItem.title);
      console.log('Wishlist length:', list.length);

      if (isWishlistPage) {
        const cardWrapper = el.closest('.card-wrapper');
        if (cardWrapper) {
          cardWrapper.style.opacity = '0.5';
          cardWrapper.style.transition = 'opacity 0.3s, transform 0.3s';
          cardWrapper.style.transform = 'scale(0.95)';

          setTimeout(() => {
            cardWrapper.remove();

            if (document.querySelectorAll('.wishlist-Product').length === 0) {
              const emptyHead = document.getElementById('page-wishlist-empty-head');
              const head = document.getElementById('page-wishlist-head');
              const link = document.getElementById('page-wishlist-link');
              const grid = document.querySelector('.grid.product-grid.wishlist');

              if (emptyHead) emptyHead.style.display = 'block';
              if (head) head.style.display = 'none';
              if (link) link.style.display = 'flex';
              if (grid) grid.style.display = 'none';
            }
          }, 300);
        }
      }
    }
    else if (!isWishlistPage) {
      const newItem = {
        id: el.dataset.id,
        title: el.dataset.title,
        handle: el.dataset.handle,
        var: varId
      };

      list.push(newItem);
      el.classList.add('active');
      updateAriaState(el, true);

      console.log('Added:', newItem.title);
      console.log('Wishlist length:', list.length);
    }
    const uniqueList = [];
    const seen = new Set();

    list.forEach((item) => {
      if (!seen.has(item.var)) {
        seen.add(item.var);
        uniqueList.push(item);
      }
    });

    saveWishlist(uniqueList);
    updateHeader(uniqueList);

    return uniqueList;
  };

  const syncButtons = () => {
    const list = getWishlist();

    document.querySelectorAll('.wishlist-Product').forEach((btn) => {
      const varId = btn.dataset.var?.toString();
      if (!varId) return;

      const isActive = list.some(
        (item) => item.var.toString() === varId
      );

      btn.classList.toggle('active', isActive);
      updateAriaState(btn, isActive);
    });

    updateHeader(list);
  };

  return {
    toggle: toggleProduct,
    syncButtons,
    getWishlist
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  SimpleWishlist.syncButtons();
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-Product');
    if (!btn) return;

    e.preventDefault();
    SimpleWishlist.toggle(btn);
  });

  if (window.location.pathname.includes('wishlist')) {
    const list = SimpleWishlist.getWishlist();
    const grid = document.querySelector('.grid.product-grid.wishlist');

    if (!list.length && grid) {
      const emptyHead = document.getElementById('page-wishlist-empty-head');
      const head = document.getElementById('page-wishlist-head');
      const link = document.getElementById('page-wishlist-link');

      grid.style.display = 'none';
      if (emptyHead) emptyHead.style.display = 'block';
      if (head) head.style.display = 'none';
      if (link) link.style.display = 'flex';
    }
  }
});
